import styled from 'styled-components';

import colors from 'themes/Main';

const { white, gray02, gray01, darkBlue } = colors;

export const Container = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const Small = styled.small`
  font-size: 14px;
  color: ${gray02};
  font-weight: 600;
`;

export const PersonName = styled.h3`
  margin: 8px 0;
  color: ${darkBlue};
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
`;

export const PersonInfos = styled.div`
  font-size: 14px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  span {
    font-weight: 700;
    color: ${gray01};
  }

  p {
    display: inline-block;
    margin-left: 4px;
    margin-bottom: 0;
    color: ${gray02};
  }
`;
